import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../framework/BaseWebComponentController';
import EasmRelatedFindingsWebComponent from '../component/EasmRelatedFindingsWebComponent';
import EasmRelatedFindingsRepository from '../repository/EasmRelatedFindingsRepository';
import EasmRelatedFindingsView from '../view/EasmRelatedFindingsView';
import easmRelatedFindingsTemplate from '../view/template';
import { EasmRelatedFindingsViewData, MIN_NR_CHARS_SEARCH } from '../types';
import { debounce } from '../../../utils/event.utils';
import { EasmSideMenuEvents } from '../../easmSideMenu/types';

export default class EasmRelatedFindingsController extends BaseWebComponentController {
  public component: EasmRelatedFindingsWebComponent;
  public dataRepository: EasmRelatedFindingsRepository;
  public view: EasmRelatedFindingsView;
  private searchText = '';

  public constructor(component: EasmRelatedFindingsWebComponent) {
    super(component);

    this.initialSetup({
      dataRepositoryConstructor: EasmRelatedFindingsRepository,
      viewConstructor: EasmRelatedFindingsView,
      viewTemplate: easmRelatedFindingsTemplate,
    });
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$backButton,
        event: 'click',
        callback: this.onBackButtonClick,
      },
      {
        element: this.view.dom.$inputSearch,
        event: 'change',
        callback: debounce(this.onInputSearchChange, 700),
      },
    ];
  }

  public async getDataForView(): Promise<EasmRelatedFindingsViewData> {
    return {
      findingClassType: this.component.findingClassType,
      findingGroups: this.dataRepository.getFindingGroups(this.component.findingGroups, this.searchText),
      findingTypeGroupToFocusOn: this.component.findingGroupTypeToFocusOn,
      searchText: this.searchText,
    };
  }

  private onBackButtonClick(): void {
    this.view.dom.$panel.dispatchEvent(
      new CustomEvent(EasmSideMenuEvents.OPEN_FINDING_DETAILS, {
        detail: { findingId: this.component.findingId },
        bubbles: true,
        composed: true,
      })
    );
  }

  private async onInputSearchChange(event: WebComponentEvent): Promise<void> {
    const searchText = event.detail.sourceEvent.replace(/\s+/g, '');

    this.searchText = searchText.length < MIN_NR_CHARS_SEARCH ? '' : searchText;

    await this.render();
  }
}
